import { PairedCostRouteItem } from '@aloft/toolkit-shared';

import { tkv2ReferenceViewIDAttr } from '../../components/ReferenceBar/consts.ts';
import { setActiveID } from '../../redux/features/referenceBarUISlice.ts';
import {
  clearFocusedCostApproachPropertyId,
  setAivArvActiveTab,
  setFocusedCostApproachPropertyId,
} from '../../redux/features/uiSlice.ts';
import { AivArvActiveTab, AppDispatch } from '../../redux/types.ts';
import { propertyIdToReferenceViewId } from '../referenceView/index.ts';

export const isCostApproachAlertFixRoute = (
  route: PairedCostRouteItem | string | undefined,
): boolean => {
  if (!route) {
    return false;
  }
  const base = route.split('?')[0]?.split('#')[0] ?? route;
  return base === 'cost-approach';
};

const getAivArvTabForProperty = (propertyId: string): AivArvActiveTab | undefined => {
  if (propertyId === 'subjectArv') {
    return 'arv';
  }
  if (propertyId === 'subject') {
    return 'aiv';
  }
  return undefined;
};

const scrollCostApproachColumnIntoView = (propertyId: string) => {
  if (propertyId === 'subject' || propertyId === 'subjectArv') {
    return;
  }

  const refId = propertyIdToReferenceViewId(propertyId);
  const column = document.querySelector(`[${tkv2ReferenceViewIDAttr}="${refId}"]`);
  column?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
};

export const focusCostApproachSliders = (dispatch: AppDispatch, propertyId: string) => {
  dispatch(setFocusedCostApproachPropertyId(propertyId));

  const aivArvTab = getAivArvTabForProperty(propertyId);
  if (aivArvTab) {
    dispatch(setAivArvActiveTab(aivArvTab));
  } else {
    dispatch(setActiveID(propertyIdToReferenceViewId(propertyId)));
  }

  window.requestAnimationFrame(() => {
    scrollCostApproachColumnIntoView(propertyId);
  });
};

export const clearFocusedCostApproachSliders = (dispatch: AppDispatch) => {
  dispatch(clearFocusedCostApproachPropertyId());
};
